<template>
  <div class="bar-2">
    <div class="grid">
      <div class="grid__item-1 news-left">
        <router-link
          :to="
            $i18nRoute({
              name: 'NewsDetail',
              params: { slug: item.url }
            })
          "
          v-for="(item, index) in list.slice(0, 6)"
          :key="item.id"
          class="news-left__item"
        >
          <div class="card" :class="`card-${index + 1}`">
            <div class="card__img">
              <div class="card__category-img">{{ item.sub_category.name }}</div>
              <ImageContainer
                style="overflow: visible; boreder-radius: 0px"
                class="img"
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
              />
            </div>
            <div class="card__descr">
              <div class="card__category-descr">
                {{ item.sub_category.name }}
              </div>
              <div class="card__title limited-text">
                {{ item.title }}
              </div>
              <div class="data-news">
                <span class="day">{{ handleDate(item.pub_date) }},</span>
                <span class="time">{{ handleTime(item.pub_date) }}</span>
              </div>
            </div>
            <div class="card__brief">
              <div class="limited-text">
                {{ item.brief }}
              </div>
              <div class="data-news-brief">
                <span class="day">{{ handleDate(item.pub_date) }},</span>
                <span class="time">{{ handleTime(item.pub_date) }}</span>
              </div>
            </div>
          </div>
        </router-link>
        <div class="bg-dark"></div>
      </div>
      <div class="grid__item-2 news-right">
        <router-link
          :to="
            $i18nRoute({
              name: 'NewsDetail',
              params: { slug: item.url }
            })
          "
          v-for="(item, index) in list.slice(6, 9)"
          :key="item.id"
          class="news-right__item"
        >
          <div class="card" :class="`card-${index + 1}`">
            <div class="card__img">
              <div class="card__category-img">{{ item.sub_category.name }}</div>
              <ImageContainer
                style="overflow: visible; boreder-radius: 0px"
                class="img"
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
              />
            </div>
            <div class="card__descr">
              <div class="card__category-descr">
                {{ item.sub_category.name }}
              </div>
              <div class="card__title limited-text">
                {{ item.title }}
              </div>
              <div class="data-news">
                <span class="day">{{ handleDate(item.pub_date) }},</span>
                <span class="time">{{ handleTime(item.pub_date) }}</span>
              </div>
            </div>
            <div class="card__brief">
              <div class="limited-text" style="--snup:5">
                {{ item.brief }}
              </div>
              <div class="data-news-brief">
                <span class="day">{{ handleDate(item.pub_date) }},</span>
                <span class="time">{{ handleTime(item.pub_date) }}</span>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";

export default {
  components: { ImageContainer },

  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.card {
  &__brief {
    display: none;
  }
  &__img {
    overflow: hidden;
    :deep() .main-image img {
      border-radius: 0px;
      overflow: visible;
    }
  }
}

.bar-2 {
  padding: 60px 0 90px;
  width: 100%;
  @media screen and (max-width: 992px) {
    padding: 15px 0 0;
  }
}
.grid {
  display: grid;
  grid-template-columns: 1fr 23%;
  gap: 70px;
  @media screen and (max-width: 992px) {
    grid-template-columns: 1fr 1fr;

    gap: 0;
  }
  &__item-1 {
    grid-column: 1 / span 1;
  }
  &__item-2 {
    grid-column: 2 / span 1;
  }
}
.news-left {
  display: grid;
  grid-template-columns: 40% 60%;
  // grid-template-rows: calc(476px + 45px) repeat(6, auto);
  // row-gap: 45px;
  .card-3 {
    position: relative;
    &::before {
      position: absolute;
      top: 125%;
      content: "";
      width: 8.5vw;
      height: 1px;
      background: #27425e;
      z-index: 3;
    }
  }
  &__item:nth-child(3) {
    position: relative;
    &::before {
      position: absolute;
      bottom: -25%;
      left: 0;
      content: "";
      width: 1px;
      height: 8vw;
      background: #27425e;
      z-index: 3;
    }
  }
  &__item:nth-child(5) {
    position: relative;
    &::before {
      position: absolute;
      top: -25%;
      left: 0;
      content: "";
      width: 1px;
      height: 8vw;
      background: #27425e;
      z-index: 3;
    }
  }
  &__item:nth-child(1) {
    grid-column: span 2;
  }
  .card {
    position: relative;
    z-index: 2;
  }
  .card-1 {
    background: inherit;
    position: relative;
    display: flex;
    gap: 2rem;
    .card__img {
      // height: 476px;
      width: 100%;
      flex: 0 0 50%;
      .img {
        padding-bottom: 76%;
      }
      .card__category-img {
        position: absolute;
        top: -1px;
        left: -1px;
        z-index: 1;
      }
    }
    .card__brief {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .card__category-img {
      display: block;
      padding: 0.2rem;
      background-color: var(--dark-bg);
    }
    .card__descr {
      position: absolute;
      left: 30%;
      background-color: var(--dark-bg);
      width: 72%;
    }
    .data-news {
      display: none !important;
    }
    .data-news-brief {
      display: block;
      margin-top: 1rem;
    }
    .card__category-descr {
      display: none;
    }
    .card__title {
      padding: 0.4rem 1rem;
      font-family: Roboto;
      font-style: normal;
      font-weight: 600;
      font-size: 36px;
      line-height: 45px;
      --snup: 2;
    }
  }
  &__item:nth-child(2),
  &__item:nth-child(4),
  &__item:nth-child(6) {
    grid-column: 1 / span 1;
  }
  &__item:nth-child(3),
  &__item:nth-child(5) {
    grid-column: 2 / span 1;
  }

  &__item:nth-child(2) {
    grid-row: 2 / span 2;
    position: relative;
    height: 100%;
    &::before {
      position: absolute;
      bottom: 0;
      content: "";
      width: 100px;
      height: 1px;
      background: #27425e;
      z-index: 3;
    }
  }

  &__item:nth-child(4) {
    grid-row: 4 / span 2;
    position: relative;
    height: 100%;

    &::before {
      position: absolute;
      bottom: 0;
      content: "";
      width: 100px;
      height: 1px;
      background: #27425e;
      z-index: 3;
    }
  }
  &__item:nth-child(6) {
    grid-row: 6 / span 2;
  }

  &__item:nth-child(3) {
    grid-row: 2 / span 3;
    align-self: center;
  }
  &__item:nth-child(5) {
    grid-row: 5 / span 3;
    align-self: center;
  }
  .bg-dark {
    background-color: #131d27;
    grid-column: 1 / span 2;
    grid-row: 2 / span 6;
    z-index: 0;
  }
  .card-2,
  .card-4,
  .card-6 {
    padding: 0 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    .card__img {
      display: none;
    }
    .card__category-descr {
      margin-bottom: 0.8rem;
    }
  }

  .card-3,
  .card-5 {
    padding: 0 2rem;
    display: flex;
    // height: 200px;
    gap: 1rem;
    .card__img {
      position: relative;
      flex: 0 0 40%;
      .img {
        padding-bottom: 73%;
      }
    }
    .card__category-img {
      position: absolute;
      top: -1px;
      left: -1px;
      z-index: 1;
      background: var(--dark-bg);
      padding: 0.2rem;
    }
    .card__category-descr {
      display: none;
    }
    .card__descr {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
    }
    .data-news {
      position: absolute;
      bottom: 0;
    }
  }
}

.news-right {
  .card {
    margin-bottom: 5rem;
    position: relative;
    .card__img {
      // height: 293px;
      position: relative;
      width: 100%;
            .img {
        padding-bottom: 74%;
      }
    }
    .card__category-img {
      display: block;
      position: absolute;
      top: -1px;
      left: -1px;
      z-index: 2;
      background: var(--dark-bg);
      padding: 0.2rem;
    }
    .card__descr {
      padding: 1.5rem 0 0 0.8rem;
      background: var(--dark-bg);
      width: 85%;
      margin-left: auto;
      position: absolute;
      right: 0;
      bottom: -20%;
      // bottom: 0;
      z-index: 2;
      .card__category-descr {
        display: none;
      }
    }
    .data-news {
      text-align: right;
    }
  }
  .card-2 {
    transform: translateY(60px);
  }
  .card-3 {
    transform: translateY(120px);
  }
}
@media screen and (max-width: 992px) {
  .news-left {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(6, 150px);
    position: relative;
    &__item {
      height: 100% !important;
      &::after,
      &::before {
        display: none;
      }
    }
    &__item:nth-child(1),
    &__item:nth-child(2),
    &__item:nth-child(3),
    &__item:nth-child(4),
    &__item:nth-child(6),
    &__item:nth-child(5) {
      grid-column: 1 / span 1;
      grid-row: span 1;
    }
    .bg-dark {
      display: block;
      position: absolute;
      height: 100%;
      width: 100%;
      grid-row: 1 / 7;
    }
    .card {
      &__img {
        display: none;
      }
      &__brief {
        display: none !important;
      }
    }
    .card-1,
    .card-2,
    .card-3,
    .card-4,
    .card-5,
    .card-6 {
      padding: 0 2.5rem;
      height: 100%;
      align-items: center;
      position: relative;
      .card__descr {
        display: block;
        position: relative;
        width: 100%;
        // height: 100%;
        left: 0;
        top: auto;
        bottom: 0;
        background: transparent;
        .card__title {
          padding: 0;
        }
        .data-news {
          display: block;
        }
      }
      .card__category-descr {
        display: block;
      }
      .data-news {
        position: relative;
      }
      &::before {
        position: absolute;
        bottom: 0;
        left: 0;
        top: auto;
        content: "";
        width: 186px;
        height: 3px;
        // background: #152331;
        background: var(--dark-bg);
        z-index: 3;
      }
      &::after {
        content: none;
      }
    }
  }

  .news-right {
    .card-1,
    .card-2,
    .card-3 {
      margin-bottom: 35px;
      transform: translate(0);
      padding: 0 4.3rem;
      .card__descr {
        position: relative;
        width: 100%;
        padding: 0;
      }
      .card__title {
        margin-top: 0.5rem;
      }
      .data-news {
        text-align: left;
      }
      .card__img {
        height: 201px;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .bar-2 {
    --height-white-block: auto;
    width: var(--main-wrapper-width);
  }
  .grid {
    grid-template-rows: var(--height-white-block) repeat(4, 160px) var(
        --height-white-block
      );
    gap: 0 1rem;
    .grid__item-1 {
      grid-column: 1 / span 2;
      grid-row: 1 / span 6;
    }
    .grid__item-2 {
      grid-column: 2 / span 1;
      grid-row: 2 / span 4;
    }
    .bg-dark {
      display: none;
    }
  }
  .news-left {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: var(--height-white-block) repeat(4, 1fr);
    gap: 2rem 0;

    &__item:nth-child(1) {
      height: 100%;
      grid-row: 1 / span 1;
    }

    &__item:nth-child(2),
    &__item:nth-child(3),
    &__item:nth-child(4),
    &__item:nth-child(5),
    &__item:nth-child(6) {
      grid-column: 1 / span 1;
    }
    &__item:nth-child(1) {
      grid-column: 1 / span 2;
    }
    &__item:nth-child(6) {
      grid-column: 1 / span 2;
    }
    .card {
      display: block;
      padding: 0;
      &__descr {
        margin-top: 0.5rem;
      }
    }
    .card-1,
    .card-6 {
      --conteiner-blog: 95%;
      display: block;
      background: #fff;
      color: var(--secondary-font-color);
      &::before {
        content: none;
      }
      .card__category-img {
        display: none;
      }
      .card__img {
        display: block;
        // flex: 1 0 273px;
        height: 273px;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          height: 105px;
          width: 100%;
          bottom: 0;
          left: 0;
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.0086472) 6.67%,
            rgba(255, 255, 255, 0.03551) 13.33%,
            rgba(255, 255, 255, 0.0816599) 20%,
            rgba(255, 255, 255, 0.147411) 26.67%,
            rgba(255, 255, 255, 0.231775) 33.33%,
            rgba(255, 255, 255, 0.331884) 40%,
            rgba(255, 255, 255, 0.442691) 46.67%,
            rgba(255, 255, 255, 0.557309) 53.33%,
            rgba(255, 255, 255, 0.668116) 60%,
            rgba(255, 255, 255, 0.768225) 66.67%,
            rgba(255, 255, 255, 0.852589) 73.33%,
            rgba(255, 255, 255, 0.91834) 80%,
            rgba(255, 255, 255, 0.96449) 86.67%,
            rgba(255, 255, 255, 0.991353) 93.33%,
            #ffffff 100%
          );
          z-index: 2;
        }
      }
      .card__descr {
        padding: 0 1rem 1rem;
        margin-top: 0.5rem !important;
        width: var(--conteiner-blog);
        margin: 0 auto;
        position: relative;
        &::before {
          content: "";
          width: 1px;
          height: 100%;
          position: absolute;
          left: 0;
          bottom: 0;
          background-color: #c4c4c4;
        }
        &::after {
          content: "";
          width: 100%;
          height: 1px;
          position: absolute;
          left: 0;
          bottom: 0;
          background-color: #c4c4c4;
        }
      }
      .card__title {
        font-family: Roboto;
        font-style: normal;
        font-weight: 600 !important;
        font-size: 18px !important;
        line-height: 23px !important;
        color: #121212 !important;
      }
      .card__category-descr {
        color: rgba(18, 18, 18, 0.7) !important;
      }
      .card__brief {
        padding: 2rem 1rem;
        width: var(--conteiner-blog);
        margin: 0 auto;
        display: block !important;
        font-family: Roboto;
        font-style: normal !important;
        font-weight: 300 !important;
        font-size: 14px !important;
        line-height: 150%;
        position: relative;
        &::after {
          content: "";
          width: 1px;
          height: 70%;
          position: absolute;
          right: 0;
          top: 0;
          background-color: #c4c4c4;
        }
      }
    }
    .card-2 {
      display: flex !important;
      flex-direction: column;
      justify-content: center;
      align-items: self-end;

      .card__img {
        height: 80px;
        margin-right: auto;
      }
    }
    .card-2,
    .card-3,
    .card-4,
    .card-5 {
      padding: 0;
      height: 100%;
      display: block;
      // width: 101%;
      .card__img {
        display: block;
        height: calc(80px + 15px);
        width: 57.51%;
      }
      .card__descr {
        display: block;
        position: relative;
        .card__title {
          padding: 0;
          margin-right: -1rem;
        }
        .data-news {
          position: relative;
          display: block !important;
        }
      }
      .card__category-img {
        position: relative;
      }
      .card__category-descr {
        display: none;
      }
      .data-news {
        position: relative;
      }
      &::before {
        content: none;
      }
      &::after {
        content: none;
      }
    }
  }
  .news-right {
    transform: translateY(6%);
    .card {
      padding: 0;
      text-align: right;
      margin-bottom: 2rem;
      // width: 101%;
      .data-news {
        text-align: right;
      }
      .card__category-img {
        position: relative;
        text-align: right;
      }
      .card__img {
        height: calc(80px + 15px);
        width: 60%;
        margin-left: auto;
        text-align: left;
      }
      .card__title {
        margin-left: -1rem;
      }
    }
  }
}
</style>
